module.exports = __webpack_public_path__ + "img/reports.08ae14b7.svg";